const header = document.getElementById('main-header');

const toggleScrollingClass = () => {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop > 50) {
        header.classList.add('scrolling');
    } else {
        header.classList.remove('scrolling');
    }
};

// Attach scroll event listener to toggle the scrolling class
window.addEventListener('scroll', toggleScrollingClass);
